import { Component, OnInit } from '@angular/core';
import { AppStateService } from '../../shared/services/app-state.service';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  // Fallback exibido quando a API não retornou um `detail` (ou veio vazio).
  readonly mensagemPadrao = 'Não foi possível carregar os dados do participante.';

  mensagem = this.mensagemPadrao;
  mensagemDaApi = false;

  constructor(
    private appStateService: AppStateService,
  ) { }

  ngOnInit(): void {
    // `detail` retornado por v1/PerfilParticipante/Portal, guardado por quem
    // redirecionou para esta tela.
    const detail = this.appStateService.getMensagemNaoApto();

    if (detail?.trim()) {
      this.mensagem = detail.trim();
      this.mensagemDaApi = true;
    }
  }
}
